import weeklyMenuActions from './actions';
import weeklyMenuActionsMutations from './mutations';
import storeResourceFactory from '../../libs/storeResourceFactory';

const menuStore = storeResourceFactory('menu', []);

const validateMenuStore = storeResourceFactory('validateMenu', null);

const state = {
  ...menuStore.state,
  ...validateMenuStore.state,
  week: {},
  weekNumber: 0,
  selectedWeek: null,
  disabledDays: {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
  },
  disabledEvents: {
    all: false,
    breakfast: false,
    lunch: false,
  },
  disabledWeekFlag: false,
  isDueDate: false,
  newMenu: {
    isValid: undefined,
    uploadedCorrectly: undefined,
  },
  isLoadingMenu: false,
};

const actions = {
  setMenu: menuStore.request(weeklyMenuActions.setMenu),
  initializeWeekMenu: menuStore.request(weeklyMenuActions.initializeWeekMenu),
  validateMenu: validateMenuStore.request(weeklyMenuActions.validateMenu),
  setDisabledDays: weeklyMenuActions.setDisabledDays,
  setDisabledEvents: weeklyMenuActions.setDisabledEvents,
  setDisableWeekFlag: weeklyMenuActions.setDisableWeekFlag,
  setWeekNumber: weeklyMenuActions.setWeekNumber,
  setSelectedWeek: weeklyMenuActions.setSelectedWeek,
  setIsDueDate: weeklyMenuActions.setIsDueDate,
  setNewMenuDefaultValues: weeklyMenuActions.setNewMenuDefaultValues,
  saveMenu: weeklyMenuActions.saveMenu,
};

const mutations = {
  ...menuStore.mutations,
  ...validateMenuStore.mutations,
  ...weeklyMenuActionsMutations,
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./store/modules/weeklyMenu/index.js